import React from "react";
import { YAxis } from "interfaces/chart";
import { OnOffSwitch } from "components/OnOffSwitch";
import { YAxisRange } from "components/DataExplorationV2/ConfigureMenu/YAxisSection/YAxisRange";
import { CurrentAxes } from "components/DataExplorationV2/ConfigureMenu/YAxisSection/CurrentAxes";
import { styled } from "@mui/material/styles";
import { Divider } from "@mui/material";

export interface YAxisProps {
  /** The status of API fetch for Parameters(Tags) and Machines */
  loading: boolean;
  error: boolean;
  /** Y-axis props and handler */
  yAxes: YAxis[] | null;
  selectedYAxis: YAxis | null;
  onChangeSelectedYAxis: (yAxis: YAxis) => void;
  onChangeYAxisMin: (min: number | null) => void;
  onChangeYAxisMax: (max: number | null) => void;
  /** Y Axis configure props and handler */
  yAxisLabelEnabled: boolean;
  onChangeYAxisLabelEnabled: (newValue: boolean) => void;
}

/** The X Axis section within the Configuration Menu */
export const YAxisSection = ({
  loading,
  error,
  yAxes,
  selectedYAxis,
  onChangeSelectedYAxis,
  onChangeYAxisMin,
  onChangeYAxisMax,
  yAxisLabelEnabled,
  onChangeYAxisLabelEnabled
}: YAxisProps): JSX.Element => {
  return (
    <SectionWrapper>
      <YAxisRange
        selectedYAxis={selectedYAxis}
        onChangeYAxisMin={onChangeYAxisMin}
        onChangeYAxisMax={onChangeYAxisMax}
      />

      <OnOffSwitch
        label="Axis Label"
        aria-label="Y Axis Label"
        labelPlacement="start"
        disabled={loading || error}
        value={yAxisLabelEnabled}
        onChange={onChangeYAxisLabelEnabled}
      />

      <StyledDivider />

      <CurrentAxes
        yAxes={yAxes}
        selectedYAxis={selectedYAxis}
        onChangeSelectedYAxis={onChangeSelectedYAxis}
      />
    </SectionWrapper>
  );
};

const SectionWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${({ theme }) => theme.spacing(2)};
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
`;

const StyledDivider = styled(Divider)`
  &.MuiDivider-root {
    margin: 0 -${({ theme }) => theme.spacing(2)} -${({ theme }) =>
        theme.spacing(1)};
  }
`;
